import { Skeleton as AntSkeleton } from "antd";
import "./style.scss";

function Skeleton({
  label = true,
  height = 44,
  count = 1,
  width = "100%",
  className = "",
}) {
  return (
    <div className={`flex gap-4 w-full skeleton-wrapper ${className}`}>
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="flex flex-col gap-1" style={{ width }}>
          {label && <AntSkeleton.Input active className="label-skeleton" />}
          <AntSkeleton.Input
            active
            style={{
              height: height,
            }}
          />
        </div>
      ))}
    </div>
  );
}

export default Skeleton;
